import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store/store";


const initialState = {
  status: ""
};

export const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    updateStatus: (state, action) => {
      state.status = action.payload;
    }
  },
});

export const { updateStatus } = statusSlice.actions;
export const getStatus = (state:RootState) => state.status.status;
export default statusSlice.reducer;